import { Helmet } from "react-helmet-async"
import { VisaBookingsList } from "../../../VisaBookings"

export default function VisaBookingsListPage() {
	return (
		<>
			<Helmet>
				<title>Visa Bookings</title>
			</Helmet>
			<VisaBookingsList />
		</>
	)
}
